<template>
  <div class="purchaseOrder">
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="送货单详情"
        width="1200px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="inspectionIncomingVO"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <table class="gridtable" style="width: 100%;" cellpadding="0" cellspacing="0">
          <tr>
            <td class="tableLabel">供应商编码:</td>
            <td style="width: 23%">{{inspectionIncomingVO.supplierNo}}</td>
            <td class="tableLabel">供应商名称:</td>
            <td style="width: 23%">{{inspectionIncomingVO.supplierName}}</td>
            <td class="tableLabel">送货人:</td>
            <td>{{inspectionIncomingVO.shipper}}</td>
          </tr>
          <tr>
            <td class="tableLabel">联系方式:</td>
            <td>{{inspectionIncomingVO.shipperPhone}}</td>
            <td class="tableLabel">送货方式:</td>
            <td>{{inspectionIncomingVO.deliveryMethod}}</td>
            <td class="tableLabel">预计发货日期:</td>
            <td>{{inspectionIncomingVO.plannedArrivalTime}}</td>
          </tr>
          <tr>
            <td class="tableLabel">预计到货日期:</td>
            <td>{{inspectionIncomingVO.deliveryDate}}</td>
            <td class="tableLabel">备注:</td>
            <td>{{inspectionIncomingVO.note}}</td>
            <td class="tableLabel"/>
            <td/>
          </tr>
        </table>
        <el-table
            :data="inspectionIncomingVO.inspectionReportVOS"
            border
            style="width: 100%">
          <el-table-column
              prop="purchaseOrderNo"
              align="center"
              label="采购订单号"
              show-overflow-tooltip
              width="100"/>
          <el-table-column prop="purchaseOrderRowNo" align="center" label="行号" width="80"/>
          <el-table-column
              prop="materialNo"
              align="center"
              label="物料编号"
              show-overflow-tooltip
              width="120"/>
          <el-table-column
              prop="materialName"
              align="left"
              label="物料描述"
              min-width="120"
              show-overflow-tooltip/>
          <el-table-column prop="requireDeliveryDate" align="center" label="交货期" width="100">
            <template slot-scope="scope">
              <span>{{scope.row.requireDeliveryDate ? scope.row.requireDeliveryDate.substring(0, 10) : ""}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="submissionNum" align="center" label="需求数" width="70"/>
          <el-table-column prop="qualifiedNum" align="center" label="合格数量" width="70"/>
          <el-table-column prop="finalStorageQuantity" align="center" label="本次入库数量" width="100">
            <template slot-scope="scope">
              <el-input v-model.trim="scope.row.finalStorageQuantity" placeholder="请输入" @input="checkQuantity(scope.row)"/>
            </template>
          </el-table-column>
          <el-table-column prop="note" align="center" label="备注" width="150">
            <template slot-scope="scope">
              <el-input v-model.trim="scope.row.note" placeholder="请输入"/>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button
            v-if="inspectionIncomingVO.inspectionReportVOS.length>0"
            type="primary"
            style="margin: 10px 0 10px 0"
            :loading="submitLoading"
            @click="submit">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "../../../util/constant";

  export default {
    name:"DeliveryInStockDetail",
    components: {},
    data() {
      return {
        constant,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        no: "",
        inspectionIncomingVO: {
          pkid:"",
          supplierNo: "", // 供应商编码
          supplierName: "", // 供应商名称
          inspectionReportVOS: [], // 送货单明细
        },
        ruleValidate: {
        },
      };
    },
    methods: {
      open(no) {
        // console.log(no);
        this.no = no;
        this.getData();
      },
      checkQuantity(row) {
        console.log(row);
        if (row.finalStorageQuantity>row.submissionNum) {
          this.$message.error("入库数量已超出");
        }
        if ( row.finalStorageQuantity== null || row.finalStorageQuantity==="") {
          this.$message.error("入库数量不能为空");
        }
        if (row.finalStorageQuantity > row.qualifiedNum) {
          this.$message.error("入库数量不可大于合格数量");
        }
      },
      getData() {
        this.$http.get("basic", "inspectionInComings/qCByPurchaseReceiveNo/" + this.no)
          .then((resp) => {
            this.inspectionIncomingVO = resp;
            console.log(resp);
            if (this.inspectionIncomingVO.inspectionReportVOS.length===0) {
              this.$message.error("该送货单质检不通过或者未质检！");
            } else {
              this.dialogVisible = true;
            }
            this.inspectionIncomingVO.inspectionReportVOS.forEach(item=>{
              if (item.finalStorageQuantity === null || item.finalStorageQuantity === "") {
                item.finalStorageQuantity = item.qualifiedNum;
              }
            });
          });
      },
      submit() {
        for (let item of this.inspectionIncomingVO.inspectionReportVOS) {
          if (item.finalStorageQuantity>item.submissionNum) {
            this.$message.error("入库数量已超出");
          }
          if ( item.finalStorageQuantity==null || item.finalStorageQuantity=="") {
            this.$message.error("入库数量不能为空");
          }
          if (item.finalStorageQuantity > item.qualifiedNum) {
            this.$message.error("入库数量不能大于合格数量");
          }
        }
        this.submitLoading = true;
        this.$http
          .put("basic", "inspectionInComings/inStock", this.inspectionIncomingVO)
          .then(() => {
            this.submitLoading = false;
            this.dialogVisible = false;
            this.$emit("save-success");
            this.$message.success("修改成功");
          })
          .catch(() => {
            this.submitLoading = false;
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .purchaseOrder{
    .el-form-item__content{
      margin-left: 2%!important;
    }
    table.gridtable {
      font-family: verdana,arial,sans-serif;
      font-size:11px;
      color:#333333;
      border: 1px solid #EBEEF5;
      border-bottom: none;
      border-left: none;
      margin-bottom: 15px;
    }
    table.gridtable tr td {
      padding: 8px;
      border-left: 1px solid #EBEEF5;
      border-bottom: 1px solid #EBEEF5;
    }
    .tableLabel {
      width: 10%;
      text-align: right;
      background-color: #D1E6F5;
      border-left: 1px solid #EBEEF5;
    }
  }

</style>
